import styled, { css } from 'styled-components';

import { OVERLAY_WIDTH_EVOLUTION } from '@/app/components/search/components/EvolutionCard/constants.ts';
import { imageWidthStyle } from '../../utils/styled';

const overlaySize = css`
  width: ${OVERLAY_WIDTH_EVOLUTION};
  min-width: ${OVERLAY_WIDTH_EVOLUTION};
  top: 73px;
`;

const defaultSize = css`
  ${imageWidthStyle};
  .alternative-dates-container & {
    width: 100%;
  }
`;

export const ArrowsContainer = styled.div<{ isRightArrow?: boolean; isOverlay?: boolean }>`
  height: 32px;
  position: absolute;
  float: left;
  left: 0;
  top: calc(50% - 16px);
  pointer-events: none;
  z-index: 2;

  @media (max-width: 767px) {
    display: none;
  }

  ${({ isOverlay }) => (isOverlay ? overlaySize : defaultSize)}
`;
